//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18nVars from '~/mixins/i18nVars'

export default {
  name: 'FreeCancellation',
  mixins: [i18nVars],
  props: {
    lang: {
      type: String,
      default: 'en'
    }
  },
  methods: {
    navigate (url) {
      if (url && url !== 'free-cancellation-link' && url !== '-') {
        window.location.href = url
      }
    }
  }
}
